/* eslint-disable no-param-reassign */
import axios from 'axios';
import env from './env';
import localStorageFacade, { LocalStorageKeys } from '../utils/localStorageFacade';

const defaultInstance = axios.create({
  baseURL: `${env.api.url}${env.api.basePath || ''}`,
  responseType: 'json',
});

const injectToken = (config) => {
  const token = localStorageFacade.get(LocalStorageKeys.AUTH_TOKEN);
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = token;
  }

  return Promise.resolve(config);
};

defaultInstance.interceptors.request.use(injectToken);

export default {
  defaultInstance,
};
